import { Component, Input } from '@angular/core';
import { Menu } from '../../models/menu.model';

/**
 * Entrada del menu lateral. Ademas del titulo muestra la pregunta que responde
 * la seccion (MENU_HINTS): con solo cinco secciones sobra espacio, y es lo que
 * hace la navegacion entendible de un vistazo.
 */
@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrl: './menu-item.component.scss',
  standalone: false,
})
export class MenuItemComponent {

  @Input({ required: true }) public menuItem!: Menu;
  /** Pregunta que responde la seccion; se oculta con el sidebar colapsado. */
  @Input() public hint = '';
  @Input() public collapsed = false;

  /* -------------------------------------------------------------------------- */
  /*                              ANCHOR tooltip                                */
  /* -------------------------------------------------------------------------- */

  /** Colapsado desaparece el texto: el title queda como unica pista. */
  public get tooltip(): string {
    return this.collapsed && this.hint
      ? `${this.menuItem.title} — ${this.hint}`
      : this.menuItem.title;
  }
}
